import { useState } from 'react';
import { useHistory } from 'react-router';
import { Link } from "react-router-dom";
import MenuOpciones from "./MenuOpciones";


const Header = () => {
  const [menuResponsive, setMenuResponsive] = useState(true);
  const menu = MenuOpciones();
  const history = useHistory();

  const enlacesMenuResponsive = (link) => {
    setMenuResponsive(!menuResponsive);
    history.push(link);
  }

  return (
    <div className="w-full ">
      {/* menu responsive */}
      <div className="flex justify-between bg-rosado lg:bg-transparent">
        <div className="  lg:hidden">
          <button
            className="h-full icon-menu text-blanco text-30 py-5 px-8 "
            onClick={() => { setMenuResponsive(!menuResponsive) }}
          ></button>
        </div>
        <div className="hidden lg:w-6/12 lg:block ">
          <img className="w-80 mt-5" src={require(`../../images/logo-fundacion-terpel.svg`).default} alt="logo terpel" />
        </div>
        <div className=" lg:w-6/12 relative overflow-hidden flex justify-end">
          <div className="hidden lg:block absolute w-80 h-32 -top-16 -right-20 bg-rosado transform rotate-12 rounded-22 shadow"></div>
          <Link to='/'>
            <img className="w-28 lg:w-40 lg:h-20 my-3 lg:mt-5 lg:mb-0 mr-3 lg:mr-8 transform lg:rotate-3 " src={require(`../../images/desing-for-change.png`).default} alt="logo design for change" />
          </Link>
        </div>
      </div>



      <div
        className="absolute w-screen bg-verde  h-screen lg:hidden z-1000 transition-all duration-500"
        style={{ left: menuResponsive ? '-100%' : 0 }}
      >
        <img className="w-60 mt-5" src={require(`../../images/logo-fundacion-terpel.svg`).default} alt="logo terpel" />
        <h2 className="text-center text-blanco poppins-700 text-26 ">Elige una  historia</h2>

        <ul className="w-full p-5 grid grid-cols-1 md:grid-cols-2 gap-4 h-3/4 overflow-scroll ">

          {
            menu.map((item, index) =>
              <button
                key={index}
                className="h-full"
                onClick={() => {
                  enlacesMenuResponsive(item.link)
                }}
              >
                <li className=" p-5 bg-verde-oscuro ">
                  <p className={` poppins-700 text-18 text-blanco una-linea-texto mb-5`}>{item.titulo}</p>
                  <div
                    className="w-full h-40 img-cover-center "
                    style={{ backgroundImage: 'url(' + require(`../../images/thumbs/${item.imagen}`).default + ')' }}
                  ></div>
                </li>

              </button>
            )
          }
        </ul>
      </div>

    </div >
  )
}

export default Header;